import { useEffect, useState, useCallback } from "react"
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { useNavigate } from "react-router-dom";
import { baseURL } from '../../../utils/api';
import { CHAVE_TOKEN } from "../../../utils/formata";

const tiposDoc = {
    contrato_social: "Contrato Social",
    documento_socio: "Documento do Sócio",
    comprovante_endereco: "Comprovante de Endereço",
    contrato_assinado: "Contrato Assinado",
    comprovante_pagamento: "Comprovante de Pagamento",
    outro: "Outro",
};

export default function DocumentoConsulta() {
    const [documentos, setDocumentos] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [filtroEmpresa, setFiltroEmpresa] = useState("");
    const [novo, setNovo] = useState({ tipo: "outro" });
    const [enviando, setEnviando] = useState(false);
    const [carregando, setCarregando] = useState(true);
    const { consultarDocumentos, consultarEmpresas, adicionarDocumento, removerDocumento } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    const carregar = useCallback(() => {
        setCarregando(true);
        consultarDocumentos(filtroEmpresa ? { empresa: filtroEmpresa } : {})
            .then((data) => setDocumentos(data || []))
            .catch((error) => setErroPadrao(error))
            .finally(() => setCarregando(false));
    }, [filtroEmpresa, consultarDocumentos, setErroPadrao]);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        consultarEmpresas().then((data) => setEmpresas(data || [])).catch(() => {});
        carregar();
    }, [carregar, consultarEmpresas, navigate]);

    function handleEnviar(e) {
        e.preventDefault();
        if (!novo.arquivo) return;
        setEnviando(true);
        const formData = new FormData();
        formData.append("arquivo", novo.arquivo);
        formData.append("tipo", novo.tipo);
        formData.append("nome", novo.nome || novo.arquivo.name);
        if (novo.EmpresaId) formData.append("EmpresaId", novo.EmpresaId);
        adicionarDocumento(formData)
            .then(() => { setNovo({ tipo: "outro" }); carregar(); })
            .catch((error) => setErroPadrao(error))
            .finally(() => setEnviando(false));
    }

    function handleExcluir(id) {
        if (!window.confirm("Excluir esse documento?")) return;
        removerDocumento(id).then(carregar).catch((error) => setErroPadrao(error));
    }

    // <a href> não manda header: o token vai na query pra API liberar o arquivo
    const urlArquivos = `${baseURL}/arquivos`;
    const comToken = (arquivo) =>
        `${urlArquivos}/${arquivo}?token=${encodeURIComponent(localStorage.getItem(CHAVE_TOKEN) || "")}`;

    return (
        <div className="pagina">
            <h2 className="he-titulo">Central de <span className="he-dourado">Documentos</span></h2>

            <form onSubmit={handleEnviar} className="he-card form-mobile" style={{margin: "1em 0"}}>
                <h6 className="he-titulo he-dourado" style={{marginBottom: "0.7em"}}><i className="bi bi-cloud-upload"></i> Enviar documento</h6>
                <div className="row">
                    <div className="col-md-3 campo-form">
                        <select className="form-select form-select-sm" value={novo.EmpresaId || ""} onChange={(e) => setNovo({...novo, EmpresaId: e.target.value})}>
                            <option value="">Sem empresa vinculada</option>
                            {empresas.map((e) => <option key={e.id} value={e.id}>{e.nomeFantasia || e.razaoSocial}</option>)}
                        </select>
                    </div>
                    <div className="col-md-3 campo-form">
                        <select className="form-select form-select-sm" value={novo.tipo} onChange={(e) => setNovo({...novo, tipo: e.target.value})}>
                            {Object.entries(tiposDoc).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                        </select>
                    </div>
                    <div className="col-md-2 campo-form">
                        <input className="form-control form-control-sm" placeholder="Nome (opcional)" value={novo.nome || ""} onChange={(e) => setNovo({...novo, nome: e.target.value})}/>
                    </div>
                    <div className="col-md-3 campo-form">
                        <input className="form-control form-control-sm" type="file" onChange={(e) => setNovo({...novo, arquivo: e.target.files[0]})}/>
                    </div>
                    <div className="col-md-1 campo-form">
                        <button type="submit" className="btn btn-sm btn-he" style={{width: "100%"}} disabled={!novo.arquivo || enviando}>
                            {enviando ? <span className="spinner-border spinner-border-sm"></span> : <i className="bi bi-check-lg"></i>}
                        </button>
                    </div>
                </div>
            </form>

            <div style={{marginBottom: "1em", width: "100%", maxWidth: 380}}>
                <select className="form-select" value={filtroEmpresa} onChange={(e) => setFiltroEmpresa(e.target.value)}>
                    <option value="">Todas as empresas</option>
                    {empresas.map((e) => <option key={e.id} value={e.id}>{e.nomeFantasia || e.razaoSocial}</option>)}
                </select>
            </div>

            {carregando ? <div style={{textAlign: "center", padding: "2em"}}><span className="spinner-border" style={{color: "#d4af37"}}></span></div> :
            <div className="he-card sem-rolagem">
                <div className="tabela-rolavel rolagem-so-desktop">
                <table className="table table-striped table-hover tabela-responsiva tabela-mini">
                    <thead>
                        <tr><th>Documento</th><th>Tipo</th><th>Empresa</th><th>Contrato</th><th>Enviado em</th><th style={{width: 120}}></th></tr>
                    </thead>
                    <tbody>
                        {documentos.map((d) => (
                            <tr key={d.id}>
                                <td className="principal" data-rotulo="Documento" style={{fontWeight: 600}}>{d.nome}</td>
                                <td data-rotulo="Tipo">{tiposDoc[d.tipo] || d.tipo}</td>
                                <td data-rotulo="Empresa">{d.Empresa ? (d.Empresa.nomeFantasia || d.Empresa.razaoSocial) : "—"}</td>
                                <td data-rotulo="Contrato">{d.EmprestimoId ? `#${d.EmprestimoId}` : "—"}</td>
                                <td data-rotulo="Enviado em">{d.createdAt}</td>
                                <td className="acoes">
                                    <div className="acoes-linha">
                                        <a className="btn btn-sm btn-outline-he" title="Abrir documento" href={comToken(d.arquivo)} target="_blank" rel="noreferrer"><i className="bi bi-box-arrow-up-right"></i><span className="so-mobile-inline"> Abrir</span></a>
                                        <button className="btn btn-sm btn-outline-danger" title="Excluir" onClick={() => handleExcluir(d.id)}><i className="bi bi-trash"></i><span className="so-mobile-inline"> Excluir</span></button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        {documentos.length === 0 && <tr><td colSpan={6} style={{textAlign: "center", color: "#9aa5b5"}}>Nenhum documento.</td></tr>}
                    </tbody>
                </table>
                </div>
            </div>}
        </div>
    )
}
